var exports = {
  "A": "menuButton__fRoJj2",
};

module.exports = exports;
